import { Box, Typography } from '@mui/material';
import React from 'react';
import colors from 'src/styles/equalution/colors';
import CoachingIcon from 'src/assets/icons/coaching.svg';
import { Button } from 'reactstrap';
import CheckIcon from '@mui/icons-material/Check';
import { isUserFromAustralia } from 'src/lib/utils';

interface Props {
  onClick: () => void;
  price?: number | string;
  isPersonalCoachingAdded?: boolean;
  isLoading: boolean;
}

export const AddOnPersonalCoachCard: React.FC<Props> = ({
  onClick,
  price = 0,
  isLoading,
  isPersonalCoachingAdded = false,
}) => {
  const isAustraliaUser = isUserFromAustralia();

  if (!isAustraliaUser) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: colors.WHITE,
        borderRadius: '20px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <img src={CoachingIcon} alt="Coach Icon" width={48} height={48} />

        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.OFF_BLACK,
            lineHeight: '24px',
          }}>
          Take your transformation to the next level with{' '}
          <span style={{ color: colors.SALAD }}>1:1 nutrition coaching</span>
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize: '12px',
          color: colors.OFF_BLACK,
          lineHeight: '12px',
          mt: 1,
        }}>
        Valid for the challenge duration only
      </Typography>

      <Button
        disabled={isPersonalCoachingAdded || isLoading}
        onClick={onClick}
        style={{
          maxWidth: '300px',
          height: '36px',
          fontWeight: 600,
          fontSize: '16px',
          width: '100%',
          backgroundColor: isPersonalCoachingAdded
            ? `${colors.OFF_BLACK}4D`
            : colors.OFF_BLACK,
          border: 'none',
          padding: 0,
        }}>
        {isPersonalCoachingAdded && (
          <CheckIcon
            sx={{ color: colors.WHITE, fontSize: 20, mb: -0.5, mr: 1 }}
          />
        )}
        {isPersonalCoachingAdded
          ? 'Added a personal coach'
          : `Add a personal coach for $${Number(price).toFixed(0)}`}
      </Button>
    </Box>
  );
};
